(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-faq"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function() {
  // Global Event Delegation: Pure body par event bind kiya taaki filter chalne ke baad bhi click kaam kare
  $('body').on('click', '.accordion-header', function(e) {
    e.preventDefault();
    
    var $thisHeader = $(this);
    var $currentItem = $thisHeader.parent('.accordion-item');
    var $currentContent = $thisHeader.next('.accordion-content');
    var $wrapper = $thisHeader.closest('.accordion-wrapper');

    // 1. Baaki saare open accordion items ko smooth slideUp ke sath close karne ke liye
    $wrapper.find('.accordion-item').not($currentItem).removeClass('active').find('.accordion-content').slideUp(300);

    // 2. Current clicked accordion ko toggle (open/close) karne ke liye
    $currentItem.toggleClass('active');
    $currentContent.slideToggle(300);
  });
});

// Shopify Admin/Theme Customizer Preview Dynamic Trigger
document.addEventListener('shopify:section:load', function() {
  $('.accordion-item').removeClass('active');
  $('.accordion-content').hide();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tag_faq_sec"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const headers = document.querySelectorAll('.accordion-header');
  
  headers.forEach(header => {
    header.addEventListener('click', function() {
      const item = this.parentElement;
      const content = this.nextElementSibling;
      
      const siblings = item.parentElement.querySelectorAll('.accordion-item');
      siblings.forEach(sibling => {
        if (sibling !== item) {
          sibling.classList.remove('active');
          sibling.querySelector('.accordion-content').style.maxHeight = null;
        }
      });

      if (item.classList.contains('active')) {
        item.classList.remove('active');
        content.style.maxHeight = null;
      } else {
        item.classList.add('active');
        content.style.maxHeight = content.scrollHeight + "px";
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
